/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Asset } from './asset';

/**
 * Perpetual Pair.
 */
export interface PerpetualPairDto {
  /**
   * Unique identifier of the perpetual pair
   */
  id?: number;
  /**
   * Trading symbol
   */
  symbol?: string;
  /**
   * Exchange name where the pair is listed
   */
  exchangeName?: PerpetualPairDto.ExchangeNameEnum;
  /**
   * Base asset of the pair
   */
  baseAsset?: Asset;
  /**
   * Quote asset of the pair
   */
  quoteAsset?: Asset;
  /**
   * Quantity scale
   */
  qtyScale?: number;
  /**
   * Price scale
   */
  priceScale?: number;
}
export namespace PerpetualPairDto {
  export const ExchangeNameEnum = {
    BinanceSpot: 'BINANCE_SPOT',
    BinancePerpetual: 'BINANCE_PERPETUAL',
    BybitSpot: 'BYBIT_SPOT',
    BybitPerpetual: 'BYBIT_PERPETUAL',
    OkxSpot: 'OKX_SPOT',
    OkxPerpetual: 'OKX_PERPETUAL',
    Aggregate: 'AGGREGATE',
    Multiply: 'MULTIPLY',
    Divide: 'DIVIDE',
    PerpSpotChaining: 'PERP_SPOT_CHAINING',
    LiquidityProvider: 'LIQUIDITY_PROVIDER',
    CoinbasePerpetual: 'COINBASE_PERPETUAL',
    KrakenSpot: 'KRAKEN_SPOT',
    CoinbaseSpot: 'COINBASE_SPOT',
  } as const;
  export type ExchangeNameEnum = (typeof ExchangeNameEnum)[keyof typeof ExchangeNameEnum];
}
